export default class ContractDeptController {
  static listRuntimeTask (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/contractDept/listRuntimeTask', 'post', params, axiosOption, httpOption);
  }

  static listHistoricTask (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/contractDept/listHistoricTask', 'post', params, axiosOption, httpOption);
  }

  static listWorkOrder (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/contractDept/listWorkOrder', 'post', params, axiosOption, httpOption);
  }

  static listApprove (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/contractDept/listApprover', 'post', params, axiosOption, httpOption);
  }
}
